// Do NOT delete or rearrange any enums in this type as it will affect all
// stored notification settings which store the numeric ordinal in a JSON
export enum BFXAppNotificationType {
  // Limit Notifications
  ACTIVATED,
  CANCELLED,
  EXPIRED,
  FILLED,
  MODIFIED,
  SUSPENDED,
  ENTERED,

  // BMARK NOTIFICATIONS
  APP_BMARK_NEW_ORDERS,
  APP_BMARK_CANCELLED,
  APP_BMARK_MODIFIED,
  APP_BMARK_FILLED,
  APP_BMARK_UNSOLICITED_CANCEL,
  APP_BMARK_ENTERED,
  PART_FILLED,

  // Algo Notification Settings
  ALGO_ACTIVATED,
  ALGO_CANCELLED,
  ALGO_EXPIRED,
  ALGO_FILLED,
  ALGO_MODIFIED,
  ALGO_ENTERED,
  ALGO_PART_FILLED,
}

export const BMARK_APP_NOTIFICATIONS: BFXAppNotificationType[] = [
  // BFXAppNotificationType.APP_BMARK_NEW_ORDERS,
  BFXAppNotificationType.APP_BMARK_CANCELLED,
  BFXAppNotificationType.APP_BMARK_MODIFIED,
  BFXAppNotificationType.APP_BMARK_FILLED,
  BFXAppNotificationType.APP_BMARK_ENTERED,
];
